import { FORTA_WHITE } from '../../utils/colors';

import type { IconProps } from './types';

const EditOutlinedIcon = (props: IconProps) => {
  const { color = FORTA_WHITE, width = 22, height = 23 } = props;

  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      viewBox={`0 0 22 23`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 2.8128C16.2626 2.55016 16.5744 2.34182 16.9176 2.19968C17.2608 2.05753 17.6286 1.98438 18 1.98438C18.3714 1.98437 18.7392 2.05753 19.0824 2.19968C19.4256 2.34182 19.7374 2.55016 20 2.8128C20.2626 3.07545 20.471 3.38725 20.6131 3.73041C20.7553 4.07357 20.8284 4.44137 20.8284 4.8128C20.8284 5.18424 20.7553 5.55203 20.6131 5.89519C20.471 6.23835 20.2626 6.55016 20 6.8128L6.5 20.3128L1 21.8128L2.5 16.3128L16 2.8128Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EditOutlinedIcon;
